module.exports = __webpack_public_path__ + "img/bf.5cfc3ec8.svg";